export default __webpack_public_path__ + "static/media/PGA-golf-logo.de1b8d63.jpg";